import React, { useState, useRef } from "react";
import {
  GameContainer,
  GameReportAnswer,
  FooterQuestion
} from "edu_lms_v2/libraries/hoc10Game/components";
import { CTA_POPUP_TYPE } from "edu_lms_v2/libraries/hoc10Game/constants";
import * as Games from "edu_lms_v2/libraries/hoc10Game/games";
import { formatActivityDataMTC_BG } from "../hoc10Game/helpers/MTC_BG";
import { handleTrackingErrorActivity } from "../hoc10Game/helpers";
import { postHistoryGame } from "edu_lms/services/readingBook";
import { ErrorView } from "./components";

const MTC_BGBook = ({ activity, bookId, showResult }) => {
  const gameRef = useRef();
  const formattedActivity = handleTrackingErrorActivity(formatActivityDataMTC_BG)(activity);

  const [indexQuestion, setIndexQuestion] = useState(0);
  const [disabledButton, setDisabledButton] = useState(true);
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [isCheckedAnswer, setIsCheckedAnswer] = useState(false);
  const [resultAnswers, setResultAnswers] = useState(
    Array(formattedActivity.error ? 0 : formattedActivity.length).fill(null)
  );

  const handlePlayGame = () => {
    setDisabledButton(false);
  };

  const handleCheckAnswerResult = () => {
    setIsCheckedAnswer(true);
    gameRef.current.handleCheck();
    gameRef.current.handleOnlyView();
  };

  const handleCompleteQuestion = ({ selectedAnswers, isCorrect }) => {
    setSelectedAnswers(selectedAnswers);

    const resultAnswersShadow = [...resultAnswers];
    resultAnswersShadow[indexQuestion] = isCorrect;
    setResultAnswers(resultAnswersShadow);
    // Post history game on book when completed
    if (bookId) {
      const historyGameData = {
        objectId: bookId,
        gameId: activity.game_id,
        dataV1: JSON.stringify({ isCorrect, selectedAnswers, activity, indexQuestion }),
      };
      postHistoryGame(historyGameData);
    }
  };

  const handleNextQuestion = () => {
    setIsCheckedAnswer(false);
    gameRef.current.handleReset();
    setIndexQuestion(indexQuestion + 1);
    setDisabledButton(true);
  };

  const handleResetAnswerResult = () => {
    setIsCheckedAnswer(false);
    gameRef.current && gameRef.current.handleReset && gameRef.current.handleReset();
    setIndexQuestion(0);
    setDisabledButton(true);
    setResultAnswers(Array(formattedActivity.length).fill(null));
  };

  const countCorrectAnswer = () => {
    const correctAnswers = formattedActivity[indexQuestion].answerCorrect.split(",");
    return correctAnswers.length;
  }

  const countSelectedCorrectAnswer = () => {
    let numberOfCorrectAnswer = 0;
    const correctAnswers = formattedActivity[indexQuestion].answerCorrect.split(",");
    correctAnswers.forEach((ans) => {
      if (selectedAnswers.includes(ans)) {
        numberOfCorrectAnswer++;
      }
    });
    return numberOfCorrectAnswer;
  };

  if (formattedActivity.error) {
    return <ErrorView />;
  }

  if (indexQuestion === formattedActivity.length) {
    return (
      <GameContainer activity={activity}>
        <GameReportAnswer
          typeReport={CTA_POPUP_TYPE.finalReport}
          total={formattedActivity.length}
          correctTotal={resultAnswers.filter((result) => result).length}
          onResetAnswer={handleResetAnswerResult}
        />
      </GameContainer>
    );
  }

  return (
    <GameContainer activity={activity}>
      <Games.MTC_BG
        ref={gameRef}
        gameData={formattedActivity[indexQuestion]}
        onPlaying={handlePlayGame}
        onComplete={handleCompleteQuestion}
        showResult={showResult}
      />
      <FooterQuestion
        resultAnswers={resultAnswers}
        indexQuestion={indexQuestion}
        disabledButton={disabledButton}
        onCheckAnswer={handleCheckAnswerResult}
        onNextQuestion={handleNextQuestion}
        onResetAnswer={handleResetAnswerResult}
      />
      {isCheckedAnswer && (
        <GameReportAnswer
          typeReport={CTA_POPUP_TYPE.rangeMultipleGame}
          total={countCorrectAnswer()}
          correctTotal={countSelectedCorrectAnswer()}
          chooseTotal={selectedAnswers.length}
        />
      )}
    </GameContainer>
  );
};

export default MTC_BGBook;
